import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Button from '@wix/da-shared-react/pkg/Button';
import CloseButton from '@wix/da-shared-react/pkg/Button/CloseButton';
import { BiEventType } from '@wix/da-shared-react/pkg/biLogger';
import { MobileContext } from '@wix/da-shared-react/pkg/Context';
import s from './WixPortfolioCallToAction.scss';

export interface Props {
  isOwner: boolean;
  isDesktopFlagEnabled: boolean;
  isMobileFlagEnabled: boolean;
  hasWixPortfolio: boolean;
  isFirstTime: boolean;
  onClickGetStarted: () => void;
  onDismiss: () => void;
}

export const WixPortfolioCallToAction: React.FC<Props> = ({
  isOwner,
  isDesktopFlagEnabled,
  isMobileFlagEnabled,
  isFirstTime,
  hasWixPortfolio,
  onClickGetStarted,
  onDismiss,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  let shouldDisplay =
    !hasWixPortfolio && isOwner && isFirstTime && isDesktopFlagEnabled;
  // Mobile is going to launch separately, so if we're on mobile, check for the mobile flag
  if (isMobile) {
    shouldDisplay = shouldDisplay && isMobileFlagEnabled;
  }
  if (!shouldDisplay) {
    return null;
  }

  return (
    <section className={s['root']}>
      <div className={s['content']}>
        <h2 className={s['heading']}>
          {t('wixPortfolio.userProfile.callToAction.heading')}
        </h2>
        <Button
          view="b14-1"
          onClick={onClickGetStarted}
          biData={{
            evid: BiEventType.WIX_PORTFOLIO_GET_STARTED_CLICK,
            sectionname: 'userprofile',
          }}
          className={s['button']}
        >
          {t('wixPortfolio.userProfile.callToAction.button')}
        </Button>
      </div>

      <div
        className={classnames(s['background-image'], s['no-image'])}
        aria-hidden="true"
      />

      <CloseButton
        onClick={onDismiss}
        className={s['close-button']}
        view="b5-3"
        biData={{
          evid: BiEventType.WIX_PORTFOLIO_CLOSE_USER_PROFILE_CTA,
          widgetname: 'userprofile-portfolio-cta',
        }}
        aria-label={t('wixPortfolio.userProfile.callToAction.a11y.dismiss')}
      />
    </section>
  );
};
WixPortfolioCallToAction.displayName = 'WixPortfolioCallToAction';

export default WixPortfolioCallToAction;
